import script from "./half-hour-trend.vue?vue&type=script&setup=true&lang=js"
export * from "./half-hour-trend.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__